// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SegmentedSelection__wrapper___SMUdj","full-width":"SegmentedSelection__full-width___5Rifg","equal-width":"SegmentedSelection__equal-width___nIQ63"};